export default __webpack_public_path__ + "static/media/globe.a2765568.svg";